import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import '../styles/Sidebar.css';
import DarkModeSwitch from './DarkModeSwitch';
import { Button } from "@heroui/react";

// Íconos Tabler
import {
  IconFileInvoice,
  IconHistory,
  IconTruck,
  IconMapRoute,
  IconGps,
  IconRoute,
  IconMessage,
  IconUser,
} from '@tabler/icons-react';

function Sidebar() {
  const navigate = useNavigate();
  const role = localStorage.getItem('role') || 'Supervisor';

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isOpen, setIsOpen] = useState(!isMobile);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
        setIsOpen(false);
      } else {
        setIsMobile(false);
        setIsOpen(true);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    alert('Sesión cerrada correctamente.');
    navigate('/');
  };

  const opcionesComunes = [
    { nombre: 'Pedidos', ruta: '/welcome/pedidos', icono: <IconFileInvoice stroke={2} size={18} style={{ marginRight: '6px' }} /> },
    { nombre: 'Pedidos Históricos', ruta: '/welcome/pedidos-historicos', icono: <IconHistory stroke={2} size={18} style={{ marginRight: '6px' }} /> },
    { nombre: 'Móviles', ruta: '/welcome/moviles', icono: <IconTruck stroke={2} size={18} style={{ marginRight: '6px' }} /> },
  ];

  const opcionesAdminSupervisor = [
    { nombre: 'Google Maps', ruta: '/welcome/google-callcenter-map', icono: <IconMapRoute stroke={2} size={18} style={{ marginRight: '6px' }} /> },
    { nombre: 'GPS', ruta: '/welcome/gps', icono: <IconGps stroke={2} size={18} style={{ marginRight: '6px' }} /> },
  ];

  const opcionesAdmin = [
    { nombre: 'Ruta Moviles', ruta: '/welcome/ruta-moviles', icono: <IconRoute stroke={2} size={18} style={{ marginRight: '6px' }} /> },
    { nombre: 'Enviar Mensajes', ruta: '/welcome/enviar-mensajes', icono: <IconMessage stroke={2} size={18} style={{ marginRight: '6px' }} /> },
    { nombre: 'Gestión de Usuarios', ruta: '/welcome/gestion-usuarios', icono: <IconUser stroke={2} size={18} style={{ marginRight: '6px' }} /> },
  ];

  let opciones = opcionesComunes;
  if (role === 'Administrador') {
    opciones = [...opcionesComunes, ...opcionesAdminSupervisor, ...opcionesAdmin];
  } else if (role === 'Supervisor') {
    opciones = [...opcionesComunes, ...opcionesAdminSupervisor];
  }

  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <h2>Menú</h2>
        {isMobile && (
          <div className="hamburger" onClick={toggleSidebar}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        )}
      </div>
      <div className={`sidebar-content ${isOpen ? 'open' : ''}`}>
        <ul>
          {opciones.map((op) => (
            <li key={op.nombre}>
              <NavLink to={op.ruta} className={({ isActive }) => (isActive ? 'active' : '')}>
                {op.icono}
                {op.nombre}
              </NavLink>
            </li>
          ))}
        </ul>

        <div style={{ marginTop: '20px' }}>
          <Button
            onClick={handleLogout}
            className="bg-gradient-to-tr from-pink-400 to-yellow-400 text-white shadow-md hover:shadow-lg px-4 py-2 flex items-center gap-2"
            radius="full"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icon-tabler-logout"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
              <path d="M9 12h12l-3 -3" />
              <path d="M18 15l3 -3" />
            </svg>
            Cerrar Sesión
          </Button>
        </div>

        <div className="dark-mode-toggle">
          <DarkModeSwitch />
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
